import { type UserProfile } from '../../utils/api/schema/profileSchema';
import { isDiiaUser } from '../../utils/billingInfoParser';

export const profileSections = {
  ACCOUNT: 'ACCOUNT',
  BILLING: 'BILLING',
  DEVICES: 'DEVICES',
  REFERAL: 'REFERAL',
} as const;

export type OneOfProfileSections = (typeof profileSections)[keyof typeof profileSections];

export const isOneOfProfileSections = (section: string): section is OneOfProfileSections => {
  return (Object.values(profileSections) as string[]).includes(section);
};

export const isReferralSectionAvailable = (profile: UserProfile) => {
  if (isDiiaUser(profile) || profile.role === 'account_role_guest') {
    return false;
  }

  if (profile.type === 'setapp' || profile.type === 'guest') {
    return false;
  }

  if (profile.subscription?.hasActiveSubscription && profile.subscription.vendor !== 'chargebee') {
    return false;
  }

  if (profile.email.endsWith('@anonymous.device')) {
    return false;
  }

  return true;
};
